// qr-export-actions.js — Modern UI + Success Trigger + Dated Filename
(function () {
  function ensureJsPDF() {
    return window.jsPDF || (window.jspdf && window.jspdf.jsPDF) || null;
  }
  function set(msg, kind, setStatus) {
    if (typeof setStatus === "function") setStatus(msg, kind);
  }
  function getText(getTextFn) { return (getTextFn && getTextFn().trim()) || ""; }

  function copyText(getTextFn, setStatus) {
    const text = getText(getTextFn);
    if (!text) return set("No approved draft yet.", "error", setStatus);
    if (!(navigator.clipboard && navigator.clipboard.writeText))
      return set("Copy not supported.", "error", setStatus);
    navigator.clipboard.writeText(text).then(() => set("Copied to clipboard.", "info", setStatus));
  }

  function exportPDF(getTextFn, setStatus, container) {
    const JsPdf = ensureJsPDF();
    if (!JsPdf) return set("PDF export not available (jsPDF missing).", "error", setStatus);
    const text = getText(getTextFn);
    if (!text) return set("No content to export.", "error", setStatus);

    const doc = new JsPdf({ unit: "pt", format: "letter", compressPdf: true });
    const mt = 72, mb = 72, ml = 54, mr = 54, lh = 16;
    const pw = doc.internal.pageSize.getWidth();
    const ph = doc.internal.pageSize.getHeight();
    const usable = pw - ml - mr;

    // --- 1. MODERN HEADER ---
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    const title = (container && container.id === "fmvOverlay") ? "CIVIC STRATEGY BRIEF" : "OFFICIAL CORRESPONDENCE";
    doc.text(title, ml, mt);
    
    // Sub-header with branding and date
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(100); // Grey color
    doc.text(`Generated via Wear It For U.S. | ${new Date().toLocaleDateString()}`, ml, mt + 22);
    
    // --- 2. BODY TEXT ---
    doc.setTextColor(0); // Reset to black
    doc.setFontSize(11);
    const lines = doc.splitTextToSize(text, usable);
    let y = mt + 60; // Start text below the header

    for (let i = 0; i < lines.length; i++) {
      if (y > ph - mb) { 
        doc.addPage(); 
        y = mt; 
      }
      doc.text(lines[i], ml, y); 
      y += lh;
    }

    // --- 3. DATED FILENAME (MMDDYYYY) ---
    const now = new Date();
    const dateStr = [
      (now.getMonth() + 1).toString().padStart(2, '0'),
      now.getDate().toString().padStart(2, '0'),
      now.getFullYear()
    ].join('');

    const baseName = (container && container.id === "fmvOverlay") ? "Find-Your-Voice" : "Write-My-Rep";
    const fileName = `${baseName}-${dateStr}.pdf`;
    
    doc.save(fileName);
    set("Exported PDF.", "info", setStatus);
  }

  function bind(opts) {
    const container = (opts && opts.container) || document;
    const getTextFn  = opts && opts.getText;
    const setStatus  = opts && opts.setStatus;

    const buttons = container.querySelectorAll("[data-action]");
    buttons.forEach(btn => {
      if (btn.dataset.bound === "1") return;
      btn.dataset.bound = "1";
      btn.addEventListener("click", e => {
        const action = e.currentTarget.getAttribute("data-action");
        if (action === "copy")   return copyText(getTextFn, setStatus);
        // Pass the container here so we can check the ID for naming/headers
        if (action === "export") return exportPDF(getTextFn, setStatus, container);
      });
    });
  }

  window.WMRExport = { bind };
})();